// SDK early listener — captures AUTH/INIT postMessage BEFORE React initialization.
// CU-869dne01h: убран '*' fallback. Без явного списка доменов — пустой массив,
// SDK ничего не примет (fail-safe). Иначе любая страница могла встраивать
// калькулятор и получать sendOutput (расчёты пользователя).
import { configureEarlyListener } from '@aseller/embed-sdk';
const _rc = (window as any).__RUNTIME_CONFIG__ as Record<string, string> | undefined;
const _originsRaw = _rc?.ALLOWED_ORIGINS || import.meta.env.VITE_ALLOWED_ORIGINS || '';
const _origins = _originsRaw.split(',').map((s: string) => s.trim()).filter(Boolean);
if (_origins.length === 0 && import.meta.env.PROD) {
  console.error(
    '[embed-security] ALLOWED_ORIGINS пуст — postMessage от Hub не будут приниматься. ' +
    'Задайте VITE_ALLOWED_ORIGINS / ALLOWED_ORIGINS в env.',
  );
}
configureEarlyListener({ allowedOrigins: _origins });

// Диагностика embed-обмена: трейс входящих (host→iframe) и исходящих postMessage
// в консоль. Ставим ДО React, чтобы поймать ранние AUTH/INIT. Управляется
// флагом __RUNTIME_CONFIG__.EMBED_DEBUG (по умолчанию включён).
import { installEmbedDebug } from './embed/embedDebug';
installEmbedDebug();

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './i18n';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
